<template>
	<div class="equipmentfailureorabnormal mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">设备故常/异常管理</div>
		</div>
		<div class="mainBot">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">设备故常/异常列表</span>
				</div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityEquipmentNo" placeholder="请输入设备编号"></el-input>
						</div>
						<div class="myinputBox">
							<!-- <el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input> -->
							<el-select clearable v-model="searchObj.communityId" allow-create filterable remote
								reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod" @change="changeSelect">
								<el-option v-for="item in restaurants" :key="item.communityId" :label="item.communityName"
									:value="item.communityId">
								</el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.equipmentStatus" slot="prepend" placeholder="请选择设备状态">
								<el-option v-for="(item,inx) in equStatusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.equipmentRunStatus" slot="prepend"
								placeholder="请选择运营状态">
								<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.count" slot="prepend" placeholder="请选择充电次数排序">
								<el-option v-for="(item,inx) in countList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					
					
				</div>
			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号" width="50">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="设备编号" width="100">
							</el-table-column>
			
							<el-table-column show-overflow-tooltip prop="communitySiteName" label="设备位置">
								<template slot-scope="scope">
									<span v-if="scope.row.communityName">{{scope.row.communityName}}-</span>
									<span>{{scope.row.communitySiteName}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentNo" label="使用率(日)">
								<template slot-scope="scope">
									<div class="clickUndline" @click="showPower(scope.row)">
										<span class="green"
											v-if=" scope.row.dayUseCount>=5 ">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
										<span class="orange"
											v-if="scope.row.dayUseCount>=3 && scope.row.dayUseCount<5">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
										<span class="red"
											v-if="scope.row.dayUseCount<3">{{((scope.row.dayUseCount/10)*100).toFixed(0)}}%</span>
									</div>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="dayUseCount" label="充电次(日)">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="monthUserCount" label="充电次(月)">
							</el-table-column>
							
							<el-table-column prop="equipmentStatus" label="状态" width="160">
								<template slot-scope="scope">
									<span v-if="scope.row.equipmentInstallStatus==1">未安装</span>
									<span v-else>{{getName(scope.row.equipmentStatus,equStatusList)}}
										<span
											v-if="scope.row.equipmentStatus==2 && scope.row.unlineFlag">({{getName(scope.row.unlineFlag,unlineFlagList)}})</span>
									</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="unlineCount" label="离线次数" width="120">
								<template slot-scope="scope">
									<div class="clickUndline" @click="showUnlineCount(scope.row)">
										{{scope.row.unlineCount}}
									</div>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="equipmentJackNumber" label="插座" width="80">
							</el-table-column>
							
							<el-table-column prop="operate" label="操作" width="50" fixed="right">
								<template slot-scope="scope">
									<el-popover class="mypopover disCenter" placement="top-end" width="100" trigger="hover">
										<div class="pupBox">
											<span class="hoverClass" @click.stop="itemClick(scope.row,3)">二维码</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,9)">功率配置</span>
											<span class="hoverClass" @click.stop="itemClick(scope.row,6)">充电记录</span>
											
											<span class="hoverClass" @click.stop="itemClick(scope.row,1)">详情</span>
											
										</div>
										<div slot="reference" class="itemRight listIcon"></div>
									</el-popover>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
						</el-pagination>
					</div>
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "equipmentfailureorabnormal",
		data() {
			return {
				PageInfo: {
					pagesize: 8,
					pagenum: 1,
					total: 0
				},
				searchObj: {
					communityId: "", //社区编号
					communitySiteId: "",
					communityEquipmentNo: "",
					equipmentStatus: "",
					equipmentRunStatus: "",
					pageNo: 1, //当前页
					pageSize: 8, //当前页个数
				},
				loading: false,
				restaurants: [],
				tableData: [],
				equStatusList: [{
						text: "正常",
						value: 1
					},
					{
						text: "离线",
						value: 2
					},
					{
						text: "故障",
						value: 3
					},
				],
				operateStatusList: [{
						text: "未投用",
						value: 1
					},
					{
						text: "运营中",
						value: 2
					},
					{
						text: "已拆除",
						value: 3
					},
				],
				countList: [{
						text: "月充电次数从低到高",
						value: 1
					},
					{
						text: "月充电次数从高到低",
						value: 2
					}
				],
			}
		},
		methods:{
			changeSelect(n) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					this.$set(this.searchObj, "communityId", item.communityId)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}
			
			
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			remoteMethod(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 5000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);
			
						}
					})
			
				} else {
					this.options = [];
				}
			},
			// 选择分页
			handleCurrentChange(val) {
				this.$set(this.PageInfo, "pagenum", val)
				this.$set(this.searchObj, "pageNo", val)
				this.getData()
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./equipmentfailureorabnormal.scss";
</style>